import type { LoaderFunctionArgs } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import Container from "~/components/layout/Container";
import { slugify } from "~/lib/slugify";
import { siteTitle } from "../../_index";
import BlogNews, { blogPosts } from "../../features/BlogNews";
import OfferBanner from "../../features/OfferBanner";
import References from "../../features/References";
import BlogDetail from "./features/BlogDetail";

export const HizmetSubTitle = "UTB Support olarak sektördeki yenilikleri, güncel gelişmeleri ve firmamızla ilgili önemli haberleri sizlerle buluşturuyoruz. Uluslararası ticaretin dinamik yapısına dair bilgi edinmek, ihracat ve ithalat süreçlerinde daha etkin olmanızı sağlayacak ipuçları ve stratejileri keşfetmek için blog yazılarımıza göz atabilirsiniz. Ayrıca şirketimizden güncel duyuruları ve etkinlikleri de “Haberler” etiketlerinden takip edebilirsiniz. Bilgi dolu içeriklerimizle yanınızdayız!";
export const loader = ({ params }: LoaderFunctionArgs) => {
  const title = HizmetSubTitle.replaceAll('ş', '<i>&#351;</i>').replaceAll('Ş', '<i>&#350;</i>').replaceAll('ğ', '<i>&#287;</i>').replaceAll('Ğ', '<i>&#286;</i>');
  const post = blogPosts.find((post) => slugify(post.title) === params.id);
  return { post, title, blogPosts };
};
export const meta = () => {
  return [{
    title: `BLOG + BİZDEN HABERLER | ${siteTitle}`,
  }]
}
export default function Page() {
  const { post, title, blogPosts } = useLoaderData<typeof loader>();

  // TODO: font turkce olarak degistir
  return (
    <div className="pt-[122px]">
      <div className="bg-white [&_#hizmetlerimiz_h2]:hidden [&>div>#hizmetlerimiz>div>p]:hidden">
        <div className="header bg-[#efefef]">
          <Container>
            <h1 className="font-raleway uppercase text-[28px] py-12 w-full font-bold">BLOG + BİZDEN HABERLER</h1>
          </Container>
        </div>
        <Container className="flex-wrap">
          <p className="text-center text-[24px] mb-12 font-lato font-light text-[#444444] relative py-12 after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:m-auto after:w-20 after:h-0.5 after:bg-[#cccccc] [&_i]:font-thin [&_i]:not-italic [&_i]:font-lato" dangerouslySetInnerHTML={{ __html: title }} />
          <BlogDetail title={post?.title} date={post?.date} excerpt={post?.excerpt} description={post?.description} image={post?.image} />
        </Container>
      </div>
      <BlogNews />
      <OfferBanner />
      <References />
    </div>
  )
}
